import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { DpBillsReportMapper } from "@domains/mapper/Reports/DpBills/DpBillReport";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class DpBillsRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getDpBillDetailsReport(req) {
        var _a;
        const url = new URL(urlConfig.dpURL + "/bills");
        let accountCode;
        if (req.accountCode)
            accountCode = req.accountCode;
        else
            accountCode = await this.accountDetails.getAccountCode();
        url.searchParams.append("accountCode", accountCode);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        url.searchParams.append("dpId", req.dpId);
        let dpBillsReportData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return DpBillsReportMapper((_a = dpBillsReportData.data) === null || _a === void 0 ? void 0 : _a.dpBills);
    }
}
export default DpBillsRepository;
